import React from "react";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";
import Pagination from "./Pagination.jsx";
import NavItemRouterLink from "./NavItem/NavItemRouterLink.jsx";
import NavItemButton from "./NavItem/NavItemButton.jsx";
import NavItemExternalLink from "./NavItem/NavItemExternalLink.jsx";

class Nav extends React.PureComponent {
  static defaultProps = {
    items: [],
    itemType: "default"
  };

  static propTypes = {
    showPerPage: PropTypes.number,
    items: PropTypes.array.isRequired,
    renderItem: PropTypes.func,
    onClick: PropTypes.func,
    itemType: PropTypes.oneOf(["default", "routing", "external"]).isRequired
  };

  render() {
    if (!this.props.items.length) {
      return null;
    }

    return (
      <NavList isStriped={true}>
        {this.props.children}
        {this.renderNav()}
      </NavList>
    );
  }

  renderNav() {
    if (!this.props.showPerPage) {
      return this.renderSimpleNav();
    }
    return this.renderNavWithPagination();
  }

  renderSimpleNav() {
    let renderItem = this.getRenderItem();
    return <div>{this.props.items.map(item => renderItem(item))}</div>;
  }

  renderNavWithPagination() {
    return (
      <Pagination
        items={this.props.items}
        renderItem={this.getRenderItem()}
        renderPrevPageButton={(active, onClick) => {
          if (!active) {
            return null;
          }
          return (
            <NavShowMoreBtn
              onClick={onClick}
              text={this.props.moreText}
              direction="less"
            />
          );
        }}
        renderNextPageButton={(active, onClick) => {
          if (!active) {
            return null;
          }
          return (
            <NavShowMoreBtn
              onClick={onClick}
              text={this.props.moreText}
              direction="more"
            />
          );
        }}
        limit={this.props.showPerPage}
      />
    );
  }

  getRenderItem() {
    let { renderItem, itemType, onClick, current } = this.props;

    if (renderItem) {
      return renderItem;
    }

    if (itemType === "routing") {
      return item => (
        <NavItemRouterLink key={item.id} title={item.name} href={item.url} />
      );
    }

    if (itemType === "external") {
      return item => (
        <NavItemExternalLink key={item.url} title={item.name} href={item.url} />
      );
    }

    return item => (
      <NavItemButton
        key={item.id}
        onClick={() => onClick(item)}
        title={item.name}
        isActive={current === item}
      />
    );
  }
}

const NavShowMoreBtn = ({ direction, onClick, text }) => {
  return (
    <button className="nav-list__more" onClick={onClick}>
      <span
        className={`glyphicon glyphicon-triangle-${
          direction == "less" ? "top" : "bottom"
        }`}
      />
      {!text ? <FormattedMessage id="app.showMore" /> : text}
    </button>
  );
};

export const NavList = ({ children, isStriped }) => (
  <nav className={`nav-list ${isStriped ? "nav-list--striped" : ""}`}>
    {children}
  </nav>
);

export default Nav;
